import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
// eslint-disable-next-line import/order
import { UzurvRestConfiguration, UzurvRestService, UZURV_REST_CONFIGURATION } from '@uzurv/http';
import { Deserialize } from 'cerialize';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { State } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class StateService extends UzurvRestService {
  readonly resourceUrl = 'states/';

  constructor(
    httpClient: HttpClient,
    @Inject(UZURV_REST_CONFIGURATION)
    protected uzurvRestConfiguration: UzurvRestConfiguration,
    domSanitizer: DomSanitizer
  ) {
    super(httpClient, uzurvRestConfiguration, domSanitizer);
  }

  /**
   * Returns a list of states
   *
   */
  getStates(): Observable<Array<State>> {
    return this.get<Array<State>>(this.resourceUrl, {
      pageNumber: 0,
      pageSize: 100
    }).pipe(map(response => Deserialize(response, State)));
  }

  /**
   * Returns a state by ID
   *
   * @param id
   */
  findStateById(id: number): Observable<State> {
    return this.getStates().pipe(map(response => response.find(state => state.id === id)));
  }

  /**
   * Returns a state by code
   *
   * @param name
   */
  findStateByCode(code: string): Observable<State> {
    return this.getStates().pipe(map(response => response.find(state => state.code === code)));
  }

  protected getApiUrl(): string {
    return this.uzurvRestConfiguration.dotsApiUrl;
  }
}
